<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <section class="border-info-subtle-active bg-info-subtle border-t px-5 py-5">
    <div class="mx-auto max-w-3xl">
      <div class="flex items-start gap-3.5">
        <span class="bg-action flex size-9 flex-none items-center justify-center rounded-[10px]" aria-hidden="true">
          <i class="pi pi-check text-base! text-white" />
        </span>

        <div class="min-w-0">
          <p class="text-action text-[10px] font-extrabold tracking-[0.14em] uppercase">{{ t('eyebrow') }}</p>

          <h3 class="text-action mt-0.5 text-[17px] leading-snug font-extrabold tracking-tight">
            {{ t('headline') }}
          </h3>

          <p class="text-ink-2 mt-1.5 text-sm">{{ t('explanation') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<i18n lang="json">
{
  "de": {
    "eyebrow": "Wir sind dran",
    "headline": "Deine Anfrage liegt vollständig bei uns",
    "explanation": "Du musst gerade nichts tun. Wir melden uns bei dir für die nächsten Schritte."
  },
  "en": {
    "eyebrow": "We are on it",
    "headline": "Your request is with us and complete",
    "explanation": "There is nothing for you to do right now. We will get in touch with you about the next steps."
  }
}
</i18n>
